<template>
  <div v-if="page" class="container py-4 py-md-5">
    <div class="row">
      <div class="col-lg-9 col-lg-offset-1">
        <div class="d-md-flex align-items-end mb-3 mb-lg-5">
          <Heading class="mb-0">
            {{ page.title }}
          </Heading>
        </div>

        <div class="page-content" v-html="page.text" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import Heading from '../components/Heading.vue';

import registrationConfirmation from '../pages/registrationConfirmation';
import passwordSent from '../pages/passwordSent';
import notFound from '../pages/404';

const pages = {};
const availablePages = [
  registrationConfirmation,
  notFound,
  passwordSent,
];

availablePages.forEach((page) => {
  pages[page.slug] = page;
});

@Component({
  name: 'DynamicPage',

  components: {
    Heading,
  },
})
export default class DynamicPage extends Vue {
  page = null;

  created() {
    const pageSlug = this.$route.params.page;

    if (typeof pages[pageSlug] === 'undefined') {
      this.$router.push({ name: '404' });
      return;
    }

    this.page = pages[pageSlug];
  }
}
</script>

<style>
.page-content {
  color: #fff;
}

.page-content a:not(.btn) {
  color: #fff;
  text-decoration: underline;
}

.page-content h1,
.page-content h2,
.page-content h3,
.page-content h4 {
  font-weight: 700;
}
</style>
